<template>
  <div class="EntCoop maxBox">
    <div class="banner EntCoop_banner"></div>
    <div class="localbk">
      <div class="local">
        <div class="elitem">当前位置：</div>
        <ul class="freenav">
          <li @click="comnt('/homePage')">首页</li>
          <li class="xiegang">/</li>
          <li @click="comnt('/guidance')">
            {{ $route.meta.text }}
          </li>
          <li class="xiegang">/</li>
          <li class="breadcrumb">
            {{
              resdata.title
            }}
          </li>
        </ul>
        <!-- <el-breadcrumb separator="/">
          <el-breadcrumb-item
            :to="{ path: '/homePage' }"
            @click.native="comnt('/homePage')"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item
            :to="{ path: '/guidance' }"
            @click.native="comnt('/guidance')"
            >{{ $route.meta.text }}</el-breadcrumb-item
          >
          <el-breadcrumb-item
          class="breadcrumb"  >{{
              resdata.title
            }}解决我的个人资料刷新后，标签不对应的问题。实现教育后端：课程提供方页面；调整侧边导航栏样式。教育前端：实现课程提供者弹窗界面，实现在线课程搜索，实现个人课程的添加功能。</el-breadcrumb-item
          >
        </el-breadcrumb> -->
      </div>
    </div>
    <!--  -->
    <div
      class="reqcontent"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255,255, 0.8)"
      style="min-height: 450px"
    >
      <div class="entreqtl" v-html="this.resdata.title"></div>
      <div class="entreqtm" v-html="this.resdata.publishtime"></div>
      <div class="entreqinfor" v-html="this.resdata.content"></div>
    </div>
  </div>
</template>
<script>
import { Loading } from "element-ui";

export default {
  components: {},
  data() {
    return {
      tl: "",
      publishtm: "",
      id: this.$store.state.paramsID,
      entreqTx: "",
      loading: true,
      path1: "/",
      resdata: "",
    };
  },
  methods: {
    comnt(e) {
      this.$router.push({ path: e });
      this.$store.commit("CHANGE_PAGE", e);
    },
    entreqMeg() {
      this.$axios({
        url:
          "Data?uid=39&layer=competitioninfo&operation=query&outfields=content,title,publishtime&queryfields=id&queryvalues=" +
          this.id,
      }).then((res) => {
        this.loading = false;
        this.resdata = res.data.data[0];
      });
    },
  },
  mounted() {
    this.entreqMeg();
  },
};
</script>
<style >
.entreqinfor {
  white-space: pre-wrap;
}

.EntCoop_banner {
  background: url("../image/entcoop.jpg");
}
</style>